<!-- 默认错误页面，error.vue会被Nuxt自动调用 -->
<template>
  <NuxtLayout name="basic-layout">
    <div class="error-box">
      <div class="error-text" v-if="stError?.statusCode === 404">
        <img src="/images/bg404.png" alt="">
        <p>页面好像迷路了</p>
        <span>抱歉，您访问的页面不存在或已被移动。</span>
        <span>请检查您输入的URL是否正确，或尝试其他链接。</span>
        <a href="javascript:void()" @click.left="HandleError">返回首页</a>
      </div>
      <div class="error-text" v-else>
        <img src="/images/bgError.png" alt="">
        <p>内部错误 {{ stError?.statusCode }}</p>
        <span>{{ stError?.message }}</span>
        <a href="javascript:void()" @click.left="HandleError">返回首页</a>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
const stError = useError()

function HandleError() { return clearError({redirect: '/'}) }

</script>

<style scoped>
.error-box {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  margin: 0 auto;
  min-height: 80vh;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  > img {
    margin: 0 auto;
    width: 250px;
  }

  .error-text {
    display: flex;
    flex-direction: column;
    align-items: center;

    > p {
      color: #333;
      text-align: center;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      margin-top: 12px;
      padding-bottom: 12px;
    }

    > span {
      margin-top: 8px;
      color: #666;
      text-align: center;
    }

    > a {
      display: flex;
      align-items: center;
      justify-content: center;

      width: 120px;
      height: 40px;
      line-height: 40px;

      margin-top: 20px;
      border-radius: 34px;
      background: linear-gradient(90deg, #7695F7 0%, #375FDF 100%);
      color: #FFF;
      text-align: center;
    }

    > a:hover {
      background: #375FDF;
    }
  }
}
</style>
